import { store, itiHttpService, itiMessageService, itiSignalRService, ItiString} from '@/iti-core-vue';
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { API } from '@/shared/api';
import { Room } from '@/shared/dtos/room';
import { EnvioMensaje } from '@/shared/dtos/envioMensaje';
import { Message } from '@/shared/dtos/message';
// import { JsonHubProtocol } from '@aspnet/signalr';

@Module({
  namespaced: true,
  name: 'ChatModule',
  store,
  dynamic: true,
})
class ChatModule extends VuexModule {
  public messages: Message[] = [];
  public rooms: Room[] = [];
  public myId: number = 0;
  public messagesLoaded: boolean = false;
  public roomsLoaded: boolean = false;

@Mutation
public setMyId(myId: number){
  this.myId = myId;
  
}
@Action
public async fetchId(){
  this.context.commit('setMessages', []);
  this.context.commit('setRooms', []);
  const url = ItiString.Format('{0}',API.chat+'/id');
  await itiHttpService.get(url,null,false)
      .catch((error) => { itiMessageService.toast(error, itiMessageService.TypeError); })
      .then((value) => this.context.commit('setMyId', Number.parseInt(value)));
}
@Mutation
public setMessages(messages: Message[]) {
  this.messages = [...messages];
}
@Mutation
public setMessagesLoaded(messagesLoaded: boolean) {
  this.messagesLoaded = messagesLoaded;
}
@Action
public async updateMessagesLoaded(messagesLoaded: boolean){
  this.context.commit("setMessagesLoaded", messagesLoaded);
}

@Action
public async fetchInitialRoomMessages(roomId: number){
  //The loading spinner is wonky, just setting it to false doesn't work all of the time.
  this.context.commit('setMessagesLoaded', true);
  this.context.commit('setMessagesLoaded', false);
  const url = ItiString.Format('{0}?roomId={1}&oldestMessageId={2}',API.chat, roomId, 0);
  await itiHttpService.get(url,null,false)
      .catch((error) => { itiMessageService.toast(error, itiMessageService.TypeError); })
      .then((value:any) => {
        var room = this.rooms.find(x => x.roomId == roomId);
        //Update room info
        if(room){
          room.unreadCount = 0;
          if(value.messages){
            if(Array.isArray(value.messages)){
              room.lastMessage = value.messages[value.messages.length-1];
            }
            else{
              room.lastMessage = value.messages;
            }
          }
        }
        //Update messages
        if(value.messages){
          if(Array.isArray(value.messages)){
            this.context.commit('setMessages', value.messages);
            if(value.messages.length === 0){
              //There's no messages in the room
              this.context.commit('setMessagesLoaded', true);
            }else{
              this.context.commit('setMessagesLoaded', !value.messagesLeft);
            }
          }
          else{
            //If there's only one message in the response
            this.context.commit('setMessages', [value.messages]);
            this.context.commit('setMessagesLoaded', !value.messagesLeft);
          }
        }
        else{
          this.context.commit('setMessagesLoaded', true);
        }
      });
}

@Mutation
public addMessages(messages: Message[]) {
    this.messages = [...messages,...this.messages];
}
@Action
public async fetchMoreRoomMessages(roomId: number){
  this.context.commit('setMessagesLoaded', true);
  this.context.commit('setMessagesLoaded', false);
  var idMensajeMasAntiguo = this.messages[0]._id;
  const url = ItiString.Format('{0}?roomId={1}&oldestMessageId={2}',API.chat, roomId, idMensajeMasAntiguo);
  await itiHttpService.get(url,null,false)
      .catch((error) => { itiMessageService.toast(error, itiMessageService.TypeError); })
      .then((value) =>{
        if(value.messages){
          if(Array.isArray(value.messages)){
            this.context.commit('addMessages', value.messages);
          }
          else{
            this.context.commit('addMessages', [value.messages]);
          }
        }
        this.context.commit('setMessagesLoaded', !value.messagesLeft);
      } );
}
@Mutation
public addMessage(mensaje: Message) {
    this.messages = [...this.messages,mensaje];
}
@Action
public async receiveMessage({mensaje, currentRoomId, roomId}:{mensaje: Message, currentRoomId: number, roomId: number}){
  if(currentRoomId == roomId){
    //We're currently in the room, show message
    this.context.commit("addMessage", mensaje);
    //Notify the server that we have read the message
    const url = ItiString.Format('{0}/readMessage?messageId={1}', API.chat, mensaje._id);
    await itiHttpService.post(url, null, false)
    .catch((error) => { itiMessageService.toast(error, itiMessageService.TypeError); });
  }
  else{
    //We're in a different room, modify "lastMessage" so it shows this message, add 1 to the counter of unread messages
    var room = this.rooms.find(x => x.roomId == roomId);
    if(room){
      room.unreadCount++;
      room.lastMessage = mensaje;
    }
  }
}
@Mutation
public setMessageAsRead(idMensaje: number){
  var mensaje = this.messages.find(x => x._id == idMensaje);
  if(mensaje){
    var indice = this.messages.indexOf(mensaje);
    if(mensaje){
      mensaje.seen = true;
    }
    this.messages[indice] = mensaje;
    this.messages = [...this.messages];
  }
}
@Action
public async messageRead(idMensaje: number){
  this.context.commit("setMessageAsRead",idMensaje);
}

@Action
public async sendMessage( {content, roomId} : {content: string, roomId: number}) {
  //Use the content and user id to build the message
  var message: Message = new Message();
    message.content =  content;
    message.senderId = this.myId;

    //Send message to server, server will pass on the message to every user in the room ( including this one )
    const url = ItiString.Format('{0}?roomId={1}', API.chat, roomId);
    await itiHttpService.post(url, message, false)
    .catch((error) => { itiMessageService.toast(error, itiMessageService.TypeError); });
}



@Mutation
public setRooms(res: any[]) {
  this.rooms = [...res]
}
@Mutation
public setRoomsLoaded(roomsLoaded: boolean) {
  this.roomsLoaded = roomsLoaded;
}
@Action 
public async loadRooms(){
    const url = ItiString.Format('{0}',API.chat+'/rooms');
    await itiHttpService.get(url, null, false, false, true)
      .catch((error) => {  })
      .then((value) => {
        if(Array.isArray(value.rooms)){
          this.context.commit('setRooms', value.rooms);
        }
        else{
          this.context.commit('setRooms', [value.rooms]);
        }
        this.context.commit('setRoomsLoaded', !value.roomsLeft);
      });
}

@Action
public async loadRoom(roomId: number): Promise<boolean>{
  const url = ItiString.Format('{0}/forChat/{1}',API.chatRoomCrud, roomId);
  await itiHttpService.get(url, null, false, false, true)
      .catch((error) => { return false;
       })
      .then((value) => {this.context.commit('setRooms', [value]); return true; });
  return false;
}

@Action
public async loadRoomId(ambitId: number): Promise<number>{
  const url = ItiString.Format('{0}/roomId/{1}',API.chatRoomCrud, ambitId);
  var val = await itiHttpService.get(url, null, false, false, true)
      .catch((error) => { return -1;
       })
      .then((value) => { return value; });
  return val;
}

@Mutation
public addRooms(salas: Room[]) {
  this.rooms = [...this.rooms,...salas];
}

@Mutation
public setLastMessagesByAmbitId(lastMessages: Message[]) {
    this.messages = [...lastMessages];
}

@Action
public async getLastMessagesByAmbitId(ambitId: number) {
    const res = await itiHttpService.get(API.chat + '/GetLastMessagesByAmbitId?ambitId=' + ambitId);
    this.context.commit('setLastMessagesByAmbitId', res.reverse());
}




}
export default getModule(ChatModule);
